<template>
	<div>
		<h1>Subgroup and Sensitivity Analysis</h1>

		<InputSelectYesNo
			question="Were subgroup analyses performed?"
			v-model="$tera.project.isSubgroupAnalysis"
			questionMark="sensitivity-analysis-1"
		/>

		<InputTextSingleLineMulti
			v-if="$tera.project.isSubgroupAnalysis"
			question="Which subgroup analyses were performed?"
			v-model="$tera.project.subgroupAnalysis"
			placeholder="e.g. children less than 5 years old and children greater than 5 years old"
			questionMark="sensitivity-analysis-2"
		/>


		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
import OutputSubgroupAndSensitivityAnalysis from "./OutputSubgroupAndSensitivityAnalysis.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";
import InputTextSingleLineMulti from "@/components/InputTextSingleLineMulti.vue";

export default {
	name: "ViewScopingSubgroupAndSensitivityAnalysis",
    components: {
        InputSelectYesNo,
        InputTextSingleLineMulti
    },
	data() {
		return {
			outputComponent: OutputSubgroupAndSensitivityAnalysis
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
